import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";
import { api } from "@/lib/apiClient";

const LanguageContext = createContext({
  lang: "de",
  setLang: () => {},
  t: (key) => key,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" && localStorage.getItem("ccc_lang");
    return saved === "en" ? "en" : "de";
  });
  const [overrides, setOverrides] = useState({}); // { de: {key: value}, en: {...} }

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  // Load overrides for the active language
  useEffect(() => {
    api
      .get(`/site-content?lang=${lang}`)
      .then((r) => {
        setOverrides((prev) => ({ ...prev, [lang]: r.data || {} }));
      })
      .catch(() => {
        // Silent: fall back to bundled translations
      });
  }, [lang]);

  const setLang = (next) => {
    setLangState(next);
    if (typeof window !== "undefined") localStorage.setItem("ccc_lang", next);
  };

  const lookup = (dict, key) =>
    key.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : null), dict);

  const t = (key) => {
    // 1. Try server-side override for current language
    const ov = overrides[lang]?.[key];
    if (ov != null && ov !== "") return ov;
    // 2. Bundled current language
    const cur = lookup(translations[lang] || {}, key);
    if (cur != null) return cur;
    // 3. Bundled German fallback
    const fb = lookup(translations.de, key);
    return fb != null ? fb : key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => useContext(LanguageContext);
